import React from 'react';
import PropTypes from 'prop-types';

function GreetingSection({ greeting }) {
  return (
    <div className="greeting-section">
      <h2>🩺 Lab Report Analysis</h2>
      <p className="greeting-text">
        {greeting || "Hello! Here's your personalized lab report analysis."}
      </p>
    </div>
  );
}

GreetingSection.propTypes = {
  greeting: PropTypes.string,
};

export default GreetingSection;